import React from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import ReportBackground from "./ReportBackground";

export default function ReportLoadingState({ message = "Memuat laporan..." }) {
  return (
    <ReportBackground style={styles.screen}>
      <View style={styles.content}>
        <ActivityIndicator size="large" color="#6724E2" />
        <Text style={styles.message}>{message}</Text>
      </View>
    </ReportBackground>
  );
}

const styles = StyleSheet.create({
  screen: { flex: 1, alignItems: "center", justifyContent: "center" },
  content: { alignItems: "center", gap: 12 },
  message: {
    color: "#5423B5",
    fontFamily: "Archivo-Regular",
    fontSize: 12,
  },
});
